export const name = 'headAppenderService' as const
